import {createAction} from 'redux-actions';
import {
  REFRESH_TOKEN,
  TEMP_USER_TO_REGULAR,
  LOGOFF,
  INVALIDATE_USER,
  DECREASE_REWARD_POINTS,
  CUSTOMER_TYPE_ALLOW
} from '../config/const';
import { updateCustomerType } from '../actions/customer_type_actions';
import CustomerType from '../const/customer_type';
import { getQueryParams } from '../selectors/uri_selectors';
import { getConfigValue } from '../reducers/configReducer';
import { setCustomerTypeQueryParameter } from '../services/uri';

const SET_USER = 'SET_USER';
const SET_TEMP_USER = 'SET_TEMP_USER';
const VERIFY_CODE_SUCCESS = 'VERIFY_CODE_SUCCESS';
const CLEAR_STORED_SIGNUP_DATA = 'CLEAR_STORED_SIGNUP_DATA';
const REFRESH_TOKEN_PENDING = 'REFRESH_TOKEN_PENDING';
const SET_IS_DEFAULT_KIOSK_CUSTOMER = 'SET_IS_DEFAULT_KIOSK_CUSTOMER';
const USE_KIOSK_USER = 'USE_KIOSK_USER';
/* ******* */
/* ACTIONS */
/* ******* */
export const useKioskUser = createAction(USE_KIOSK_USER, user => user);
export const setUserAction = createAction(SET_USER, user => user);
export const setUser = user => (dispatch, getState) => {
  const queryParams = getQueryParams(getState());
  const customerTypeAllowed = getConfigValue(CUSTOMER_TYPE_ALLOW, getState());
  setCustomerTypeQueryParameter(user.customerType);
  if (customerTypeAllowed === CustomerType.ALL 
    && user.customerType && !queryParams.customerType) {
    dispatch(updateCustomerType(user.customerType, false));
  }

  dispatch(setUserAction(user));
};

export const setTempUserAction = createAction(SET_TEMP_USER, user => user);

export const setTempUser = user => dispatch => {
  dispatch(setTempUserAction(user));

  if (user.customerType) {
    dispatch(updateCustomerType(user.customerType));
  }
};

export const logOffAction = createAction(LOGOFF);

export const logOff = user => dispatch => {
  dispatch(logOffAction(user));
  dispatch(updateCustomerType(CustomerType.ALL));
};

export const invalidateUser = () => {
  // if (stompClient && stompClient.connected) stompClient.disconnect();
  return {type: INVALIDATE_USER};
};
export const refreshTokenPending = createAction(REFRESH_TOKEN_PENDING, state => state);

/* ****** */
/* STATE  */
/* ****** */
const initialState = {
  firstName: 'John',
  lastName: 'Apple',
  phone: '',
  rewardPoints: '',
  redemeedPoints: '',
  rewardTier: '',
  id: null,
  isRec: false,
  isID: false,
  tempUser: {},
  tokens: {
    refreshTokenPending: false
  },
  isKioskCustomer: false,
  isFetched: false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
  case USE_KIOSK_USER: {
    return {
      ...state,
      ...action.payload,
      isKioskCustomer: true
    };
  }
  case SET_USER: {
    // const user = {...action.payload, ...capitalizeName(action.payload)}
    // const user = {...action.payload, ...capitalizeName(action.payload)}
    return {
      ...state,
      ...action.payload,
      isKioskCustomer: false
    };
  }
  case INVALIDATE_USER:
  case LOGOFF:
    return {
      ...initialState
    };
  case SET_TEMP_USER: {
    return {
      ...state,
      tempUser: {
        ...state.tempUser,
        ...action.payload
      }
    };
  }
  case CLEAR_STORED_SIGNUP_DATA:
    return {
      ...state,
      tempUser: {}
    };
  case TEMP_USER_TO_REGULAR:
    return {
      ...state,
      ...state.tempUser,
      tempUser: null
    };
  case REFRESH_TOKEN:
    return {
      ...state,
      tokens: {
        ...state.tokens,
        ...action.payload
      }
    };
  case VERIFY_CODE_SUCCESS:
    return {
      ...state,
      tokens: {
        ...state.tokens,
        ...action.payload.data.tokens,
      }
    };
  case REFRESH_TOKEN_PENDING:
    return {
      ...state,
      tokens: {
        ...state.tokens,
        refreshTokenPending: action.payload
      }
    };
  case SET_IS_DEFAULT_KIOSK_CUSTOMER:
    return {
      ...state,
      isKioskCustomer: action.payload
    };
  default: {
    return state;
  }
  }
};
export function isDocs(state) {
  return state.user.isID && state.user.isRec;
}
export function isAdult(state) {
  return state.user.adult;
}
export function hasRec(state) {
  return state.user.isRec;
}
export function hasID(state) {
  return state.user.isID;
}
export function getFullName(state) {
  const fullName = [state.user.firstName, state.user.lastName];
  return fullName.join(' ');
}
export function isUser(state) {
  return !!state.user.tokens.token && !!state.user.id;
}
export function isKioskUser(state) {
  return !!state.kioskUser.tokens.token;
}
export function userId(state) {
  return state.user.id;
}
export function getTempUserName(state) {
  const fullName = [state.user.tempUser.firstName, state.user.tempUser.lastName];
  return fullName.join(' ');
}
export function getTempUserPhone(state) {
  return state.user.tempUser.phone;
}

export function getRewardsDollars(state) {
  if (!state || !state.user || !state.user.rewardPoints) {
    return `$0.00`
  }

  return (state.user.rewardPoints / 100).formatMoney()
}

export default userReducer;



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js